import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FullscreenOutlined from '@ant-design/icons/FullscreenOutlined';
import CloseOutlined from '@ant-design/icons/CloseOutlined';

export default function FullscreenBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if running as installed PWA
    const isPWA = window.matchMedia('(display-mode: standalone)').matches
      || window.matchMedia('(display-mode: fullscreen)').matches
      || window.navigator.standalone === true;

    // Detect iOS/iPadOS - fullscreen API is not supported
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    // Only show in PWA mode, not on iOS, and not already in fullscreen
    if (isPWA && !isIOS && !document.fullscreenElement) {
      setShow(true);
    }
  }, []);

  const handleEnterFullscreen = () => {
    document.documentElement.requestFullscreen()
      .then(() => setShow(false))
      .catch(() => setShow(false));
  };

  const handleClose = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <>
      {/* Overlay to block interaction with the app */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          bgcolor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 9998,
        }}
      />
      {/* White bar centered horizontally */}
      <Box
        sx={{
          position: 'fixed',
          top: 16,
          left: '50%',
          transform: 'translateX(-50%)',
          bgcolor: 'white',
          color: 'text.primary',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
          py: 1.5,
          px: 3,
          zIndex: 9999,
          borderRadius: 1,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 500, color: 'text.secondary' }}>
          Open in fullscreen for best experience
        </Typography>
        <Button
          variant="contained"
          size="small"
          startIcon={<FullscreenOutlined />}
          onClick={handleEnterFullscreen}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
          }}
        >
          Enter Fullscreen
        </Button>
        <Button
          variant="outlined"
          size="small"
          startIcon={<CloseOutlined />}
          onClick={handleClose}
          sx={{
            textTransform: 'none',
          }}
        >
          Close
        </Button>
      </Box>
    </>
  );
}
